const onGtetDefaultCompanyName = () => {
  switch (process.env.ENV_TYPE) {
    case 'development':
      return '/images/light_Logo.png';
    case 'dcc':
      return '/images/dcc_light_Logo.png';
    default:
      return '/images/light_Logo.png'
  }
}

export const userInfoInitState = {
  companyInfo: {
    companyName: '',
  },
  companyLogo: '',
  userInfo: {
    // name: 'admin',
    // email: 'admin@bitoss.cn',
    // position: 'test'
  },
  userInfoLoading: false
}

export const userInfoReducer = (
  state = userInfoInitState,
  action
) => {
  switch (action.type) {
    // 用户信息
    case 'SET_USER_INFO': {
      return {
        ...state,
        userInfo: { ...action.payload },
      }
    }
    // 请求用户信息加载状态
    case 'SET_USER_LOADING': {
      return {
        ...state,
        loading: action.payload,
      }
    }
    // 公司信息
    case 'SET_COMPANY_INFO': {
      return {
        ...state,
        companyInfo: { ...action.payload }
      }
    }
    // 公司Logo
    case 'SET_COMPANY_LOGO': {
      return {
        ...state,
        companyLogo: action.payload
      }
    }
    default: {
      return state;
    }
  }
}